// removed by extract-text-webpack-plugin
module.exports = {"header":"PlaneDetails__header__3pu4A","plane-table-description":"PlaneDetails__plane-table-description__JEJll","range-maps":"PlaneDetails__range-maps__5qmes"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OurAircraft/PlaneDetails/PlaneDetails.scss
// module id = 444
// module chunks = 0